import FormatISODate from "../../../../../../../../global/FormatISODate";
import ValueWithFallback from "../../../../../../../../global/ValueWithFallback";

import { STRINGS } from "./strings";

export default function getUpdatedString(user, date) {
  const userNameStr = ValueWithFallback(user, STRINGS.NA);
  let dateStr = "";
  if (!date) {
    return dateStr + "" + userNameStr;
  }
  dateStr = FormatISODate(date);
  const deliminator = dateStr !== "" ? " " : "";

  return dateStr + deliminator + userNameStr;
}
